import { makeStyles } from '@material-ui/core/styles';

const drawerWidth = '243px';
const closedDrawerWidth = '80px';
const useStyles = makeStyles((theme) => ({
  notLoggedIn: {
    height: '100vh',
    width: '100vw',
    backgroundColor: theme.palette.primary.main,
  },
  logoContainer: {
    backgroundColor: theme.palette.white.main,
    borderRadius: '5px',
    padding: '16px 0 16px 16px',
    justifyContent: 'center',
  },
  root: {
    position: 'relative',
    paddingLeft: closedDrawerWidth,
    minHeight: '100vh',
  },
  content: {
    backgroundColor: theme.palette.background.default,
    padding: '60px 0',
  },
  logoIcon: {
    padding: '25px 0 50px 15px',
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    backgroundColor: theme.palette.black.light,
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(10),
    },
  },
}));

export default useStyles;
